__turbopack_context__.v({
  "fill": "progress-module__Asu-Aq__fill",
  "fillIndeterminate": "progress-module__Asu-Aq__fillIndeterminate",
  "lg": "progress-module__Asu-Aq__lg",
  "ring": "progress-module__Asu-Aq__ring",
  "ringDot": "progress-module__Asu-Aq__ringDot",
  "ringFill": "progress-module__Asu-Aq__ringFill",
  "ringGlyph": "progress-module__Asu-Aq__ringGlyph",
  "ringQueued": "progress-module__Asu-Aq__ringQueued",
  "ringSvg": "progress-module__Asu-Aq__ringSvg",
  "ringTrack": "progress-module__Asu-Aq__ringTrack",
  "toneSage": "progress-module__Asu-Aq__toneSage",
  "track": "progress-module__Asu-Aq__track",
});
